// import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
// import { getS3URL } from "../../../../_helpers";
// import ChapterVideo from "./chapterVideo";
// import ChapterDocument from "./chapterDocument";
// import { MediaTypes, documentTypeUrl } from "../../../../_constants/staticData";
// import axiosInstance from "../../../../axios";
// import Button from "../../../Other/element/Button";
// import Image from "../../../Other/element/Image";
// import ChapterImagePreview from "./chapterImagePreview";
// import { ChevronDown, ChevronUp } from "lucide-react";

// const CourseChapter = ({
//   index,
//   mainTitle,
//   title,
//   content,
//   view,
//   status,
//   TimeConversion,
//   ID,
//   updateChapterData,
//   sectionId,
//   acknowledge,
//   fetchData,
//   videoLink,
//   scroms,
//   syllabusId,
//   syllabusName,
// }) => {
//   const [isActive, setIsActive] = useState(false);
//   const [getImage, setGetImage] = useState();
//   const [duration, setDuration] = useState();
//   const [getDocument, setGetDocument] = useState([]);
//   const [show, setShow] = useState(false);
//   const [getVideo, setGetVideo] = useState([]);
//   const [viewDocument, setViewDocument] = useState();
//   const [chapterCompletion, setChapterCompletion] = useState(acknowledge);
//   const [secondaryCompletion, setSecondaryCompletion] = useState(false);
//   const [mappedPreviewImage, setMappedPreviewImage] = useState([]);
//   const [isImageShow, setIsImageShow] = useState(false);
//   const [mapped, setMapped] = useState([]);
//   const childCompRef = useRef();
//   const firstRun = useRef(true);
//   const [courseDetailId, setCourseDetailId] = useState();

//   useEffect(() => {
//     let videoList = [];
//     let duration = [];
//     let document = [];
//     let image = [];

//     if (Array.isArray(view)) {
//       view.forEach((element) => {
//         if (MediaTypes.videoType.includes(element?.fileExt) || element?.videoLink) {
//           videoList.push(element);
//           duration.push(element?.duration);
//         } else if (MediaTypes.documentTypes.includes(element?.fileExt)) {
//           document.push({
//             name: getS3URL(element.fileName),
//             type: element.fileExt,
//           });
//         } else if (MediaTypes?.imageTypes.includes(element.fileExt)) {
//           document.push({
//             name: getS3URL(element.fileName),
//             type: element.fileExt,
//           });
//         }
//         setCourseDetailId(element.courseDetailId);
//       });
//     } else {
//       console.warn("view is not an array:", view);
//     }

//     setGetVideo(videoList);
//     setDuration(duration);
//     setGetDocument(document);
//     setGetImage(image);
//   }, [view]);

//   const documentViewerHandler = (type) => {
//     setMapped(
//       getDocument.filter((item) => {
//         return item.type === type;
//       })
//     );
//     setShow(true);
//   };

//   const imagePreviewHandler = (type) => {
//     setMappedPreviewImage(
//       getDocument.filter((item) => {
//         return item.type === type;
//       })
//     );
//     setIsImageShow(!isImageShow);
//   };

//   const closeHandler = () => {
//     setShow(!show);
//   };

//   const imagePreviewCloseHandler = () => {
//     setIsImageShow(!isImageShow);
//   };

//   useEffect(() => {
//     if (childCompRef.current) {
//       childCompRef.current.acknowledgeCompleteChapter();
//     }
//   }, [chapterCompletion]);

//   const courseChapterCompletion = async (isFinished) => {
//     try {
//       await axiosInstance.post(
//         "course/section/progress",
//         JSON.stringify({
//           courseDetailId: sectionId,
//           isFinished: isFinished,
//         }),
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       updateChapterData(sectionId, isFinished);
//       fetchData(ID);

//     } catch (error) {
//       console.error("Error updating course chapter progress:", error);
//     }
//   };

//   const completionHandler = () => {
//     const updatedStatus = !chapterCompletion;
//     setChapterCompletion(updatedStatus);
//     setSecondaryCompletion(!secondaryCompletion);
//     courseChapterCompletion(updatedStatus);
//   };

//   useEffect(() => {
//     if (firstRun.current) {
//       firstRun.current = false;
//       return;
//     }
//     courseChapterCompletion();
//   }, [secondaryCompletion]);

//   return (
//     <div className="bg-white rounded-xl shadow-sm border border-gray-100 mb-4 overflow-hidden transition-all duration-300 hover:shadow-md" key={index}>
//       {/* Header */}
//       <div
//         className={`flex items-center justify-between p-6 cursor-pointer transition-all duration-300 ${isActive ? 'bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-gray-100' : 'hover:bg-gray-50'
//           }`}
//         onClick={() => setIsActive(!isActive)}
//       >
//         <div className="flex items-center space-x-4 flex-1">
//           {/* Expand/Collapse Button */}
//           <div className={`flex items-center justify-center w-8 h-8 rounded-full transition-all duration-300 ${isActive ? 'bg-blue-500 text-white rotate-180' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
//             }`}>
//             <svg className="w-4 h-4 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
//             </svg>
//           </div>

//           {/* Chapter Title */}
//           <div className="flex-1">
//             <h3 className="text-lg font-semibold text-gray-800 leading-tight">{title}</h3>
//           </div>
//         </div>

//         {/* Status and Duration */}
//         <div className="flex items-center space-x-3">
//           {chapterCompletion && (
//             <div className="flex items-center space-x-2 bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-medium">
//               <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
//               </svg>
//               <span>Complete</span>
//             </div>
//           )}

//           {duration && (
//             <div className="text-sm text-gray-500 bg-gray-100 px-3 py-1 rounded-full">
//               {TimeConversion(duration)}
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Content */}
//       {isActive && (
//         <div className="p-6 space-y-6 bg-gray-50">
//           {/* Chapter Description */}
//           {content && (
//             <div
//               className="prose prose-sm max-w-none text-gray-600 bg-white p-4 rounded-lg border border-gray-100"
//               dangerouslySetInnerHTML={{ __html: content }}
//             />
//           )}

//           {/* External Video Link */}
//           {/* {videoLink && (
//             <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
//               <ChapterVideo
//                 checked={chapterCompletion}
//                 ref={childCompRef}
//                 videoLink={videoLink}
//               />
//             </div>
//           )} */}

//           {/* Videos */}
//           {getVideo && getVideo.length > 0 && (
//             <div className="space-y-4">
//               <h4 className="text-lg font-semibold text-gray-800 flex items-center">
//                 <svg className="w-5 h-5 mr-2 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
//                   <path d="M2 6a2 2 0 012-2h6l2 2h6a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" />
//                   <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m9 12 2 2 4-4" />
//                 </svg>
//                 Videos
//               </h4>
//               <div key={index} className="flex w-full border rounded-md gap-4 overflow-x-auto">
//                 {getVideo.map((fileItem, index) => (
//                   <div key={index} className="bg-white rounded-lg h-[400px] w-[400px] overflow-hidden">
//                     <ChapterVideo
//                       data={getS3URL(fileItem.fileName)}
//                       details={fileItem}
//                       checked={chapterCompletion}
//                       ref={childCompRef}
//                       videoLink={undefined}
//                     />
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* SCORM Content */}

//           {/* {scroms && scroms.length > 0 && (
//             <div className="space-y-4">
//               <h4 className="text-lg font-semibold text-gray-800 flex items-center">
//                 <svg className="w-5 h-5 mr-2 text-purple-500" fill="currentColor" viewBox="0 0 20 20">
//                   <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
//                 </svg>
//                 Interactive Content
//               </h4>
//               {scroms.map((items, index) => (
//                 <div key={index} className="bg-white rounded-lg border border-gray-200 overflow-hidden">
//                   <iframe
//                     height="500px"
//                     width="100%"
//                     className="rounded-lg"
//                     src={`https://scorm-smiklearn.s3.us-east-2.amazonaws.com/${items.entryPoint}`}
//                   />
//                 </div>
//               ))}
//             </div>
//           )} */}

//           {/* Documents Section */}

//           {/* {getDocument?.length > 0 && (
//             <div className="space-y-4">
//               <div className="flex items-center justify-between">
//                 <h4 className="text-lg font-semibold text-gray-800 flex items-center">
//                   <svg className="w-5 h-5 mr-2 text-green-500" fill="currentColor" viewBox="0 0 20 20">
//                     <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
//                   </svg>
//                   Documents & Resources
//                 </h4>

//                 <button
//                   onClick={() => setViewDocument(!viewDocument)}
//                   className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-all duration-200 ${viewDocument
//                     ? 'bg-blue-500 text-white shadow-md hover:bg-blue-600'
//                     : 'bg-white text-blue-500 border border-blue-200 hover:bg-blue-50'
//                     }`}
//                 >
//                   <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
//                   </svg>
//                   <span>{viewDocument ? 'Hide Documents' : 'View Documents'}</span>
//                 </button>
//               </div>

//               {viewDocument && (
//                 <div className="bg-white rounded-lg border border-gray-200 p-6">
//                   <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">

//                     {getDocument
//                       .filter((items) => items.type === "pdf")
//                       .map((ele, index) => (
//                         <div
//                           key={index}
//                           className="flex flex-col items-center p-4 bg-red-50 rounded-lg border border-red-100 hover:bg-red-100 transition-colors cursor-pointer group"
//                           onClick={() => documentViewerHandler("pdf")}
//                         >
//                           <div className="w-12 h-12 mb-2 flex items-center justify-center">
//                             <Image
//                               url={documentTypeUrl.pdf}
//                               alt="PDF file"
//                               className="w-full h-full object-contain group-hover:scale-110 transition-transform"
//                             />
//                           </div>
//                           <span className="text-xs text-gray-600 text-center">PDF</span>
//                         </div>
//                       ))}


//                     {getDocument
//                       .filter((items) => items.type === "xlsx")
//                       .map((ele, index) => (
//                         <div
//                           key={index}
//                           className="flex flex-col items-center p-4 bg-green-50 rounded-lg border border-green-100 hover:bg-green-100 transition-colors cursor-pointer group"
//                           onClick={() => documentViewerHandler("xlsx")}
//                         >
//                           <div className="w-12 h-12 mb-2 flex items-center justify-center">
//                             <Image
//                               url={documentTypeUrl.excel}
//                               alt="Excel file"
//                               className="w-full h-full object-contain group-hover:scale-110 transition-transform"
//                             />
//                           </div>
//                           <span className="text-xs text-gray-600 text-center">Excel</span>
//                         </div>
//                       ))}


//                     {getDocument
//                       .filter((items) => items.type === "docx")
//                       .map((ele, index) => (
//                         <div
//                           key={index}
//                           className="flex flex-col items-center p-4 bg-blue-50 rounded-lg border border-blue-100 hover:bg-blue-100 transition-colors cursor-pointer group"
//                           onClick={() => documentViewerHandler("docx")}
//                         >
//                           <div className="w-12 h-12 mb-2 flex items-center justify-center">
//                             <Image
//                               url={documentTypeUrl.msWord}
//                               alt="Word file"
//                               className="w-full h-full object-contain group-hover:scale-110 transition-transform"
//                             />
//                           </div>
//                           <span className="text-xs text-gray-600 text-center">Word</span>
//                         </div>
//                       ))}


//                     {getDocument
//                       .filter((items) => items.type === "pptx")
//                       .map((ele, index) => (
//                         <div
//                           key={index}
//                           className="flex flex-col items-center p-4 bg-orange-50 rounded-lg border border-orange-100 hover:bg-orange-100 transition-colors cursor-pointer group"
//                           onClick={() => documentViewerHandler("pptx")}
//                         >
//                           <div className="w-12 h-12 mb-2 flex items-center justify-center">
//                             <Image
//                               url={documentTypeUrl.pptx}
//                               alt="PowerPoint file"
//                               className="w-full h-full object-contain group-hover:scale-110 transition-transform"
//                             />
//                           </div>
//                           <span className="text-xs text-gray-600 text-center">PowerPoint</span>
//                         </div>
//                       ))}

//                     {getDocument
//                       .filter((items) => items.type === "ppt")
//                       .map((ele, index) => (
//                         <div
//                           key={index}
//                           className="flex flex-col items-center p-4 bg-orange-50 rounded-lg border border-orange-100 hover:bg-orange-100 transition-colors cursor-pointer group"
//                           onClick={() => documentViewerHandler("ppt")}
//                         >
//                           <div className="w-12 h-12 mb-2 flex items-center justify-center">
//                             <Image
//                               url={documentTypeUrl.ppt}
//                               alt="PowerPoint file"
//                               className="w-full h-full object-contain group-hover:scale-110 transition-transform"
//                             />
//                           </div>
//                           <span className="text-xs text-gray-600 text-center">PowerPoint</span>
//                         </div>
//                       ))}


//                     {getDocument
//                       .filter((items) => items.type && MediaTypes.imageTypes.includes(items.type))
//                       .map((ele, index) => (
//                         <div
//                           key={index}
//                           className="flex flex-col items-center p-4 bg-purple-50 rounded-lg border border-purple-100 hover:bg-purple-100 transition-colors cursor-pointer group"
//                           onClick={() => imagePreviewHandler(ele.type)}
//                         >
//                           <div className="w-12 h-12 mb-2 flex items-center justify-center overflow-hidden rounded">
//                             <img
//                               src={ele.name}
//                               alt="Course Image"
//                               className="w-full h-full object-cover group-hover:scale-110 transition-transform"
//                             />
//                           </div>
//                           <span className="text-xs text-gray-600 text-center">Image</span>
//                         </div>
//                       ))}
//                   </div>
//                 </div>
//               )}
//             </div>
//           )} */}

//           {/* Completion Checkbox */}
//           {status === true && (
//             <div className="bg-white rounded-lg border border-gray-200 p-6">
//               <label className="flex items-center space-x-3 cursor-pointer group">
//                 <div className="relative">
//                   <input
//                     type="checkbox"
//                     checked={chapterCompletion}
//                     onChange={completionHandler}
//                     className="sr-only"
//                   />
//                   <div className={`w-6 h-6 rounded border-2 transition-all duration-200 ${chapterCompletion
//                     ? 'bg-green-500 border-green-500'
//                     : 'border-gray-300 group-hover:border-green-400'
//                     }`}>
//                     {chapterCompletion && (
//                       <svg className="w-4 h-4 text-white absolute top-0.5 left-0.5" fill="currentColor" viewBox="0 0 20 20">
//                         <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
//                       </svg>
//                     )}
//                   </div>
//                 </div>
//                 <span className="text-gray-700 font-medium">
//                   I acknowledge that I have completed this section.
//                 </span>
//               </label>
//             </div>
//           )}
//         </div>
//       )}

//       {/* Document Modals */}
//       {/* {show && mapped && mapped.length > 0 && (
//         <>
//           {mapped.map((element, index) => (
//             <ChapterDocument
//               key={index}
//               url={element.name}
//               type={element.type}
//               show={show}
//               closeHandler={closeHandler}
//             />
//           ))}
//         </>
//       )} */}

//       {/* Image Preview Modals */}
//       {/* {isImageShow && mappedPreviewImage && mappedPreviewImage.length > 0 && (
//         <>
//           {mappedPreviewImage.map((element, index) => (
//             <ChapterImagePreview
//               key={index}
//               url={element.name}
//               type={element.type}
//               show={isImageShow}
//               closeHandler={imagePreviewCloseHandler}
//             />
//           ))}
//         </>
//       )} */}
//     </div>
//   );
// };

// export default CourseChapter;


import React, { useState, useEffect, useRef } from "react";
import { getS3URL } from "../../../../_helpers";
import ChapterVideo from "./chapterVideo";
import { MediaTypes } from "../../../../_constants/staticData";
import axiosInstance from "../../../../axios";
import { X, Play, CheckCircle, Clock, ChevronDown, PlayCircle, ChevronUp } from "lucide-react";
import Modal from "@/pages/Other/Modal";

const CourseChapter = ({
  index,
  title,
  content,
  view,
  status,
  TimeConversion,
  ID,
  updateChapterData,
  sectionId,
  acknowledge,
  fetchData,
}) => {
  const [duration, setDuration] = useState();
  const [getVideo, setGetVideo] = useState([]);
  const [chapterCompletion, setChapterCompletion] = useState(acknowledge);
  const [secondaryCompletion, setSecondaryCompletion] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const childCompRef = useRef();
  const firstRun = useRef(true);
  const [courseDetailId, setCourseDetailId] = useState();
  const [openSections, setOpenSections] = useState({});

  useEffect(() => {
    let videoList = [];
    let duration = [];

    if (Array.isArray(view)) {
      view.forEach((element) => {
        if (MediaTypes.videoType.includes(element?.fileExt) || element?.videoLink) {
          videoList.push(element);
          duration.push(element?.duration);
        }
        setCourseDetailId(element.courseDetailId);
      });
    } else {
      console.warn("view is not an array:", view);
    }

    setGetVideo(videoList);
    setDuration(duration);
  }, [view]);

  useEffect(() => {
    if (childCompRef.current) {
      childCompRef.current.acknowledgeCompleteChapter();
    }
  }, [chapterCompletion]);

  useEffect(() => {
    setChapterCompletion(acknowledge);
  }, [acknowledge]);

  const courseChapterCompletion = async (isFinished) => {
    try {
      await axiosInstance.post(
        "course/section/progress",
        JSON.stringify({
          courseDetailId: sectionId,
          isFinished: isFinished,
        }),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      updateChapterData(sectionId, isFinished);
      fetchData(ID);

    } catch (error) {
      console.error("Error updating course chapter progress:", error);
    }
  };

  const completionHandler = () => {
    const updatedStatus = !chapterCompletion;
    setChapterCompletion(updatedStatus);
    setSecondaryCompletion(!secondaryCompletion);
    courseChapterCompletion(updatedStatus);
  };

  const handleVideoEnded = () => {
    if (!chapterCompletion) {
      setChapterCompletion(true);
      setSecondaryCompletion(!secondaryCompletion);
      courseChapterCompletion(true);
    }
  };

  const openVideoModal = (video) => {
    setSelectedVideo(video);
    setShowVideoModal(true);
  };

  const closeVideoModal = () => {
    setShowVideoModal(false);
    setSelectedVideo(null);
  };

  useEffect(() => {
    if (firstRun.current) {
      firstRun.current = false;
      return;
    }
    courseChapterCompletion();
  }, [secondaryCompletion]);

  const toggleSection = (index) => {
    setOpenSections((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };
  return (
    <div className="group relative" key={index}>

      <div className={`relative bg-white rounded-2xl border-2 transition-all duration-500 ease-out mb-6 overflow-hidden border-transparent bg-gradient-to-br from-blue-50 via-white to-indigo-50 shadow-xl shadow-blue-100/50 scale-[1.02]'shadow-lg shadow-[#264b82]/40`}>

        <div className={`relative flex items-center justify-between p-6 cursor-pointer transition-all duration-300 pb-4 hover:bg-gradient-to-r hover:from-gray-50/50 hover:to-blue-50/30`} onClick={() => toggleSection(index)}>
          <div className="flex items-center space-x-5 flex-1">
            {/* Modern chapter number badge */}
            <div className={`relative flex-shrink-0 w-12 h-12 rounded-2xl flex items-center justify-center font-bold text-lg transition-all duration-300 bg-gradient-to-br from-[#264b82]/80 to-[#264b82] text-white shadow-lg shadow-[#264b82]/20`}>
              {chapterCompletion ? (
                <CheckCircle className="w-6 h-6" />
              ) : (
                <span>{index + 1}</span>
              )}
            </div>

            {/* Enhanced chapter title */}
            <div className="flex-1 min-w-0">
              <h3 className={`text-xl font-bold leading-tight transition-colors duration-300 text-[#264b82]`}>
                {title}
              </h3>
              <div className="flex items-center mt-1 space-x-3">
                {duration && (
                  <div className="flex items-center space-x-1 text-sm text-gray-500">
                    <Clock className="w-4 h-4" />
                    <span>{TimeConversion(duration)}</span>
                  </div>
                )}
                {getVideo && getVideo.length > 0 && (
                  <div className="flex items-center space-x-1 text-sm text-blue-600">
                    <PlayCircle className="w-4 h-4" />
                    <span>Video Available</span>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Right side controls */}
          <div className="flex items-center space-x-4">
            {status === true && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  completionHandler();
                }}
                className={`flex items-center space-x-2 px-4 py-2.5 rounded-xl border font-bold text-xs transition-all duration-300 ${
                  chapterCompletion
                    ? "bg-green-50 text-green-700 border-green-200 hover:bg-green-100"
                    : "bg-white text-gray-600 border-gray-200 hover:bg-gray-50"
                }`}
              >
                {chapterCompletion ? (
                  <>
                    <CheckCircle className="w-4.5 h-4.5 text-green-600 shrink-0" />
                    <span>Completed</span>
                  </>
                ) : (
                  <>
                    <div className="w-4 h-4 rounded-full border-2 border-gray-300 shrink-0" />
                    <span>Mark Complete</span>
                  </>
                )}
              </button>
            )}

            {/* Video preview button */}
            {getVideo && getVideo.length > 0 ? (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  openVideoModal(getVideo[0]);
                }}
                className="group/btn relative px-6 py-3 bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white rounded-xl font-semibold transition-all duration-300 shadow-lg shadow-blue-200 hover:shadow-xl hover:shadow-blue-300 hover:scale-105 flex items-center space-x-2"
              >
                <Play className="w-5 h-5 group-hover/btn:scale-110 transition-transform duration-200" />
                <span>Start Learning</span>
              </button>
            ) : (<button
              disabled
              className="group/btn relative px-6 py-3 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-xl font-semibold transition-all duration-300 shadow-lg shadow-blue-200 flex items-center space-x-2 opacity-50 cursor-not-allowed"
            >
              Coming Soon
            </button>
            )}

            {openSections[index] ?
              <ChevronUp size={20} /> :
              <ChevronDown size={20} />
            }
          </div>
        </div>
        {openSections[index] && (
          <div className="p-4 bg-gray-50 text-gray-700 border-t">
            {content ? (
              <div
                dangerouslySetInnerHTML={{ __html: content }}
                className="prose prose-sm max-w-none"
              />
            ) : (
              <p className="text-gray-500 italic">Course content details will be available soon.</p>
            )}
          </div>
        )}
      </div>

      {/* Enhanced Video Modal */}
      {showVideoModal && selectedVideo && (
        <Modal isOpen={showVideoModal} onClose={closeVideoModal}>
          <div className="w-full h-[90vh] overflow-hidden ">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-100 bg-gradient-to-r from-gray-50 to-white">
              <h2 className="text-2xl font-bold text-gray-800">{title}</h2>
            </div>

            {/* Modal Content */}
            <div className="p-6">
              <div className="aspect-video bg-black rounded-2xl overflow-hidden shadow-xl">
                <ChapterVideo
                  data={getS3URL(selectedVideo.fileName)}
                  details={selectedVideo}
                  checked={chapterCompletion}
                  ref={childCompRef}
                  videoLink={undefined}
                  onVideoEnded={handleVideoEnded}
                />
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default CourseChapter;
